import { FieldStates } from './fieldStateConstants';

export const getMuiStyleOverrides = (fieldStates?: FieldStates) => ({
  components: {
    MuiSelect: {
      styleOverrides: {
        select: {
          whiteSpace: 'nowrap',
          '@media (min-width: 600px)': {
            whiteSpace: 'normal',
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          whiteSpace: 'normal',
        },
      },
    },
    MuiStep: {
      styleOverrides: {
        root: {
          paddingLeft: 0,
          paddingRight: 0,
        },
      },
    },
    ...(fieldStates?.enabled && {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            '.asb-state-border &:not(.Mui-focused):not(.Mui-error) .MuiOutlinedInput-notchedOutline':
              { borderColor: 'var(--asb-border)' },
            '.asb-state-focused &.Mui-focused:not(.Mui-error) .MuiOutlinedInput-notchedOutline':
              { borderColor: 'var(--asb-focused)' },
            '&.Mui-error .MuiOutlinedInput-notchedOutline': {
              borderColor: 'var(--asb-error)',
            },
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            '.asb-state-border &:not(.Mui-focused):not(.Mui-error)': {
              color: 'var(--asb-border)',
            },
            '.asb-state-focused &.Mui-focused:not(.Mui-error)': {
              color: 'var(--asb-focused)',
            },
            '&.Mui-error': { color: 'var(--asb-error)' },
          },
        },
      },
    }),
  },
});
